module.exports = __webpack_public_path__ + "img/Лицензния-на-фарм.-деятельность-15.08.2016_Page_2_Image_0001.bdbb4376.jpg";